import * as types from '@/store/mutation-types'

const state = {
  memberInfo: null, // 用户信息
  memberPower: null // 用户权限
}

const mutations = {
  [types.UPDATE_MEMBERINFO] (state, newVal) {
    state.memberInfo = newVal
  },
  [types.UPDATE_MEMBERPOWER] (state, newVal) {
    state.memberPower = newVal
  }
}

export default {
  state,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/common/modules/user.js